/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Southern Wind Warehouse API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdjustmentCreate,
  BatchCreate,
  BatchDetail,
  BatchOut,
  PageBatchOut,
  PageStockRow,
  ProblemDetail,
  StockExpiringParams,
  StockListBatchesParams,
  StockStockParams
} from '../../model';

import { apiRequest } from '../../../http';
import type { ErrorType , BodyType } from '../../../http';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Партии
 */
export const stockListBatches = (
    params?: StockListBatchesParams,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<PageBatchOut>(
      {url: `/api/v1/batches`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      options);
    }
  



export const getStockListBatchesQueryKey = (params?: StockListBatchesParams,) => {
    return [
    `/api/v1/batches`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getStockListBatchesQueryOptions = <TData = Awaited<ReturnType<typeof stockListBatches>>, TError = ErrorType<ProblemDetail>>(params?: StockListBatchesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stockListBatches>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStockListBatchesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof stockListBatches>>> = ({ signal }) => stockListBatches(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stockListBatches>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StockListBatchesQueryResult = NonNullable<Awaited<ReturnType<typeof stockListBatches>>>
export type StockListBatchesQueryError = ErrorType<ProblemDetail>


export function useStockListBatches<TData = Awaited<ReturnType<typeof stockListBatches>>, TError = ErrorType<ProblemDetail>>(
 params: undefined |  StockListBatchesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stockListBatches>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stockListBatches>>,
          TError,
          Awaited<ReturnType<typeof stockListBatches>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStockListBatches<TData = Awaited<ReturnType<typeof stockListBatches>>, TError = ErrorType<ProblemDetail>>(
 params?: StockListBatchesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stockListBatches>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stockListBatches>>,
          TError,
          Awaited<ReturnType<typeof stockListBatches>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStockListBatches<TData = Awaited<ReturnType<typeof stockListBatches>>, TError = ErrorType<ProblemDetail>>(
 params?: StockListBatchesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stockListBatches>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Партии
 */

export function useStockListBatches<TData = Awaited<ReturnType<typeof stockListBatches>>, TError = ErrorType<ProblemDetail>>(
 params?: StockListBatchesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stockListBatches>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStockListBatchesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Приёмка партии (товар существующий или новый; срок годности необязателен)
 */
export const stockReceive = (
    batchCreate: BodyType<BatchCreate>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<BatchOut>(
      {url: `/api/v1/batches`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: batchCreate, ...(signal ? { signal }: {})
    },
      options);
    }
  


export const getStockReceiveMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stockReceive>>, TError,{data: BodyType<BatchCreate>}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof stockReceive>>, TError,{data: BodyType<BatchCreate>}, TContext> => {

const mutationKey = ['stockReceive'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stockReceive>>, {data: BodyType<BatchCreate>}> = (props) => {
          const {data} = props ?? {};

          return  stockReceive(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StockReceiveMutationResult = NonNullable<Awaited<ReturnType<typeof stockReceive>>>
    export type StockReceiveMutationBody = BodyType<BatchCreate>
    export type StockReceiveMutationError = ErrorType<ProblemDetail>

    /**
 * @summary Приёмка партии (товар существующий или новый; срок годности необязателен)
 */
export const useStockReceive = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stockReceive>>, TError,{data: BodyType<BatchCreate>}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stockReceive>>,
        TError,
        {data: BodyType<BatchCreate>},
        TContext
      > => {

      const mutationOptions = getStockReceiveMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Партия с журналом движений
 */
export const stockGetBatch = (
    batchId: number,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<BatchDetail>(
      {url: `/api/v1/batches/${batchId}`, method: 'GET', ...(signal ? { signal }: {})
    },
      options);
    }
  



export const getStockGetBatchQueryKey = (batchId?: number,) => {
    return [
    `/api/v1/batches/${batchId}`
    ] as const;
    }

    
export const getStockGetBatchQueryOptions = <TData = Awaited<ReturnType<typeof stockGetBatch>>, TError = ErrorType<ProblemDetail>>(batchId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stockGetBatch>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStockGetBatchQueryKey(batchId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof stockGetBatch>>> = ({ signal }) => stockGetBatch(batchId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(batchId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stockGetBatch>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StockGetBatchQueryResult = NonNullable<Awaited<ReturnType<typeof stockGetBatch>>>
export type StockGetBatchQueryError = ErrorType<ProblemDetail>


export function useStockGetBatch<TData = Awaited<ReturnType<typeof stockGetBatch>>, TError = ErrorType<ProblemDetail>>(
 batchId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stockGetBatch>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stockGetBatch>>,
          TError,
          Awaited<ReturnType<typeof stockGetBatch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStockGetBatch<TData = Awaited<ReturnType<typeof stockGetBatch>>, TError = ErrorType<ProblemDetail>>(
 batchId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stockGetBatch>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stockGetBatch>>,
          TError,
          Awaited<ReturnType<typeof stockGetBatch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStockGetBatch<TData = Awaited<ReturnType<typeof stockGetBatch>>, TError = ErrorType<ProblemDetail>>(
 batchId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stockGetBatch>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Партия с журналом движений
 */

export function useStockGetBatch<TData = Awaited<ReturnType<typeof stockGetBatch>>, TError = ErrorType<ProblemDetail>>(
 batchId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stockGetBatch>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStockGetBatchQueryOptions(batchId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Списание порчи (с кладовщика) или инвентаризационная корректировка (менеджер)
 */
export const stockAdjust = (
    batchId: number,
    adjustmentCreate: BodyType<AdjustmentCreate>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<BatchOut>(
      {url: `/api/v1/batches/${batchId}/adjustments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adjustmentCreate, ...(signal ? { signal }: {})
    },
      options);
    }
  


export const getStockAdjustMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stockAdjust>>, TError,{batchId: number;data: BodyType<AdjustmentCreate>}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof stockAdjust>>, TError,{batchId: number;data: BodyType<AdjustmentCreate>}, TContext> => {

const mutationKey = ['stockAdjust'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stockAdjust>>, {batchId: number;data: BodyType<AdjustmentCreate>}> = (props) => {
          const {batchId,data} = props ?? {};

          return  stockAdjust(batchId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StockAdjustMutationResult = NonNullable<Awaited<ReturnType<typeof stockAdjust>>>
    export type StockAdjustMutationBody = BodyType<AdjustmentCreate>
    export type StockAdjustMutationError = ErrorType<ProblemDetail>

    /**
 * @summary Списание порчи (с кладовщика) или инвентаризационная корректировка (менеджер)
 */
export const useStockAdjust = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stockAdjust>>, TError,{batchId: number;data: BodyType<AdjustmentCreate>}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stockAdjust>>,
        TError,
        {batchId: number;data: BodyType<AdjustmentCreate>},
        TContext
      > => {

      const mutationOptions = getStockAdjustMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Остатки по товарам
 */
export const stockStock = (
    params?: StockStockParams,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<PageStockRow>(
      {url: `/api/v1/stock`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      options);
    }
  



export const getStockStockQueryKey = (params?: StockStockParams,) => {
    return [
    `/api/v1/stock`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getStockStockQueryOptions = <TData = Awaited<ReturnType<typeof stockStock>>, TError = ErrorType<ProblemDetail>>(params?: StockStockParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stockStock>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStockStockQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof stockStock>>> = ({ signal }) => stockStock(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stockStock>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StockStockQueryResult = NonNullable<Awaited<ReturnType<typeof stockStock>>>
export type StockStockQueryError = ErrorType<ProblemDetail>


export function useStockStock<TData = Awaited<ReturnType<typeof stockStock>>, TError = ErrorType<ProblemDetail>>(
 params: undefined |  StockStockParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stockStock>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stockStock>>,
          TError,
          Awaited<ReturnType<typeof stockStock>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStockStock<TData = Awaited<ReturnType<typeof stockStock>>, TError = ErrorType<ProblemDetail>>(
 params?: StockStockParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stockStock>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stockStock>>,
          TError,
          Awaited<ReturnType<typeof stockStock>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStockStock<TData = Awaited<ReturnType<typeof stockStock>>, TError = ErrorType<ProblemDetail>>(
 params?: StockStockParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stockStock>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Остатки по товарам
 */

export function useStockStock<TData = Awaited<ReturnType<typeof stockStock>>, TError = ErrorType<ProblemDetail>>(
 params?: StockStockParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stockStock>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStockStockQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Истекает в ближайшие N дней (включая просроченные)
 */
export const stockExpiring = (
    params?: StockExpiringParams,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<PageBatchOut>(
      {url: `/api/v1/stock/expiring`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      options);
    }
  



export const getStockExpiringQueryKey = (params?: StockExpiringParams,) => {
    return [
    `/api/v1/stock/expiring`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getStockExpiringQueryOptions = <TData = Awaited<ReturnType<typeof stockExpiring>>, TError = ErrorType<ProblemDetail>>(params?: StockExpiringParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stockExpiring>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStockExpiringQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof stockExpiring>>> = ({ signal }) => stockExpiring(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stockExpiring>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StockExpiringQueryResult = NonNullable<Awaited<ReturnType<typeof stockExpiring>>>
export type StockExpiringQueryError = ErrorType<ProblemDetail>


export function useStockExpiring<TData = Awaited<ReturnType<typeof stockExpiring>>, TError = ErrorType<ProblemDetail>>(
 params: undefined |  StockExpiringParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stockExpiring>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stockExpiring>>,
          TError,
          Awaited<ReturnType<typeof stockExpiring>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStockExpiring<TData = Awaited<ReturnType<typeof stockExpiring>>, TError = ErrorType<ProblemDetail>>(
 params?: StockExpiringParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stockExpiring>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stockExpiring>>,
          TError,
          Awaited<ReturnType<typeof stockExpiring>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStockExpiring<TData = Awaited<ReturnType<typeof stockExpiring>>, TError = ErrorType<ProblemDetail>>(
 params?: StockExpiringParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stockExpiring>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Истекает в ближайшие N дней (включая просроченные)
 */

export function useStockExpiring<TData = Awaited<ReturnType<typeof stockExpiring>>, TError = ErrorType<ProblemDetail>>(
 params?: StockExpiringParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stockExpiring>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStockExpiringQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




